import React from "react";
import "./app.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/home/home";
import About from "./pages/about/about";
import Ach from "./pages/achievements/ach";
import Gallery from "./pages/gallery/gallery";
import Contact from "./pages/contact/contact";
import MapContainer from "./pages/location/location";
import Services from "./pages/services/services";
import Footer from "./components/footer/footer";
import Navigation from './components/navbar/navigation';

function App() {
    return (
        <Router>
            <Navigation />
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='about' element={<About />} />
                <Route path='gallery' element={<Gallery />} />
                <Route path='contact' element={<Contact />} />
                <Route path='location' element={<MapContainer />} />
                <Route path='services' element={<Services />} />
                <Route path='achievements' element={<Ach />} />
            </Routes>
            <Footer />
        </Router>
    );
};

export default App;